import { defineComponent, h, useAttrs } from 'vue'
import { VWindowItem } from 'vuetify/components'

export default defineComponent({
  name: 'VTabItemCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,

  setup(_, { slots }) {
    const attrs = useAttrs()

    return () => h(VWindowItem, attrs, slots)
  }
})
